/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable sonarjs/no-duplicate-string */

import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Filter from './Filter';

const FilterW = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  return <Filter
    {...props}
    location={location}
    navigate={navigate}
  />;
};
export default FilterW;
